export type ReconciliationStatus = "pending" | "matched" | "difference";

const calendarMonthPattern = /^\d{4}-(0[1-9]|1[0-2])$/;

export function isCalendarMonth(value: string): boolean {
  return calendarMonthPattern.test(value);
}

export function isDateInCalendarMonth(date: string, month: string): boolean {
  if (!isCalendarMonth(month)) return false;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  if (!match || date.slice(0, 7) !== month) return false;
  const [year, monthNumber, day] = match.slice(1).map(Number);
  const parsed = new Date(Date.UTC(year, monthNumber - 1, day));
  return parsed.getUTCFullYear() === year
    && parsed.getUTCMonth() === monthNumber - 1
    && parsed.getUTCDate() === day;
}

export function calendarMonthBounds(month: string): { start: string; end: string } {
  if (!isCalendarMonth(month)) throw new Error("自然月格式必须为 YYYY-MM");
  const [year, monthNumber] = month.split("-").map(Number);
  const lastDay = new Date(Date.UTC(year, monthNumber, 0)).getUTCDate();
  return { start: `${month}-01`, end: `${month}-${String(lastDay).padStart(2, "0")}` };
}

export function currentCalendarMonth(date = new Date()): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

export function reconciliationDifference(expectedAmountMinor: number, actualAmountMinor: number | null): number | null {
  if (!Number.isSafeInteger(expectedAmountMinor) || expectedAmountMinor === 0) {
    throw new Error("应收金额必须为非零安全整数");
  }
  if (actualAmountMinor === null) return null;
  if (!Number.isSafeInteger(actualAmountMinor)) throw new Error("实收金额必须为安全整数");
  const difference = actualAmountMinor - expectedAmountMinor;
  if (!Number.isSafeInteger(difference)) throw new Error("差额超出安全整数范围");
  return difference;
}

export function reconciliationStatus(expectedAmountMinor: number, actualAmountMinor: number | null): ReconciliationStatus {
  const difference = reconciliationDifference(expectedAmountMinor, actualAmountMinor);
  if (difference === null) return "pending";
  return difference === 0 ? "matched" : "difference";
}
